import React from 'react';
import { TimesheetDayStatus } from '../../types';
import {
  daysInMonth, weekdayLabel, isWeekend, isToday, statusDisplay, dayCellBtnCls,
} from './timesheetUtils';

interface DayCellsProps {
  month: string; // yyyy-MM
  days: Record<string, TimesheetDayStatus>;
  onToggle: (day: number) => void;
}

/** The full month of clickable day cells for one person, wrapping to fit the
 *  screen — day number and weekday sit above each cell so rows never cram. */
const DayCells: React.FC<DayCellsProps> = ({ month, days, onToggle }) => {
  const totalDays = daysInMonth(month);
  const dayNumbers = Array.from({ length: totalDays }, (_, i) => i + 1);

  return (
    <div className="flex flex-wrap gap-1.5">
      {dayNumbers.map((day) => {
        const status = days[String(day)] || 'off';
        const display = statusDisplay[status];
        const weekend = isWeekend(month, day);
        const today = isToday(month, day);
        return (
          <div key={day} className={`flex flex-col items-center rounded-md px-0.5 pb-0.5 ${weekend ? 'bg-sky-50' : ''}`}>
            <div className={`text-[10px] leading-tight font-medium ${today ? 'text-ocean-600' : weekend ? 'text-sky-600' : 'text-gray-400'}`}>
              {weekdayLabel(month, day)}
            </div>
            <div className={`text-[11px] leading-tight font-semibold mb-0.5 ${today ? 'text-ocean-700' : 'text-gray-600'}`}>
              {day}
            </div>
            <button
              type="button"
              title={`Day ${day}: ${statusDisplay[status].title}`}
              onClick={() => onToggle(day)}
              className={`${dayCellBtnCls} ${display.cls} ${today ? 'ring-2 ring-ocean-400' : ''}`}
            >
              {display.symbol}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default DayCells;
